import { render } from "./NewBoxToggle.vue?vue&type=template&id=64a233bf&scoped=true"
import script from "./NewBoxToggle.vue?vue&type=script&lang=js"
export * from "./NewBoxToggle.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a233bf"]])

export default __exports__